// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rKAE","type":"styles_type__2gJ-v","choices":"styles_choices__30Anv"};